import React from "react";

class PrintSubscriptionForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: "",
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        this.setState({
            selectedOption: e.target.value,
        });
    }

    handleSubscribeClick = (e) => {
        e.preventDefault();
        const printOptions = [
            {
                id: "on-campus",
                name: "On Campus Print Subscription",
                description: "Subscribe to receive print copies delivered to your campus location.",
                url: "https://dailyprincetonian.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=Annual-Prince-Subscription---On-Campus-USD-Monthly&subscription[start_date]=1788192000&utm_source=cb-app-copy",
            },
            {
                id: "off-campus",
                name: "Off Campus Print Subscription",
                description: "Subscribe to receive print copies delivered to your off-campus address.",
                url: "https://dailyprincetonian.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=Annual-Prince-Subscription---Off-Campus-USD-Monthly&subscription[start_date]=1788192000&utm_source=cb-app-copy",
            },
        ];

        if (!this.state.selectedOption) {
            alert("Please select a print subscription option.");
            return false;
        }

        const selectedOption = printOptions.find((opt) => opt.id === this.state.selectedOption);
        if (selectedOption) {
            window.open(selectedOption.url, "_blank", "noopener,noreferrer");
        }

        return false;
    };

    render() {
        const printOptions = [
            {
                id: "on-campus",
                name: "On Campus Print Subscription",
                description: "Subscribe to receive print copies delivered to your campus location.",
                url: "https://dailyprincetonian.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=Annual-Prince-Subscription---On-Campus-USD-Monthly&subscription[start_date]=1788192000&utm_source=cb-app-copy",
            },
            {
                id: "off-campus",
                name: "Off Campus Print Subscription",
                description: "Subscribe to receive print copies delivered to your off-campus address.",
                url: "https://dailyprincetonian.chargebee.com/hosted_pages/checkout?subscription_items[item_price_id][0]=Annual-Prince-Subscription---Off-Campus-USD-Monthly&subscription[start_date]=1788192000&utm_source=cb-app-copy",
            },
        ];

        return (
            <div className="subscription-form" style={{ flex: "1" }}>
                <img
                    src="https://assets.dailyprincetonian.com/common/banner-transparent.png"
                    alt="banner"
                    className="logo-image"></img>
                <h1 style={{ textAlign: "center", fontSize: "32px", fontWeight: "700", textTransform: "uppercase", marginBottom: "15px", marginTop: "10px" }}>
                    PAPER PRINT SUBSCRIPTION
                </h1>
                <h1 className="firstbox-text" style={{ textAlign: "center", lineHeight: "24px", marginTop: "18px" }}>
                    Subscribe to receive physical print copies delivered to your door every week for one semester (11 weeks).
                </h1>
                <h1 className="firstbox-text" style={{ textAlign: "center", lineHeight: "24px", fontWeight: "normal" }}>
                    This year, the ‘Prince’ celebrates <strong>150 years</strong> of serving the Princeton community. A print subscription keeps you connected to campus life while supporting <strong>more than 400 independent student journalists</strong>. Click below to subscribe!
                </h1>
                <hr />
                <div className="checklist-form">
                    {printOptions.map((item) => (
                        <label key={item.id}>
                            <input
                                type="radio"
                                name="print-subscription"
                                value={item.id}
                                checked={this.state.selectedOption === item.id}
                                onChange={this.handleChange}
                                className="checkbox-title"
                            />
                            &emsp;{item.name}
                            <br /> <p className="description">{item.description}</p>
                        </label>
                    ))}
                </div>
                <hr />
                <div className="submit-button">
                    <a href="#" onClick={this.handleSubscribeClick} className="print-subscribe-link">
                        <input style={{ fontSize: "30px" }} className="subscribe" type="button" value="SUBSCRIBE" />
                    </a>
                </div>
                <br />
                <br />
                <div className="tiny-links">
                    <p>
                        <i>
                            If you encounter problems or have any questions, contact the Business Team at{" "}
                            <a href="mailto:subscriptions@dailyprincetonian.com" className="tiny-link">
                                business@dailyprincetonian.com
                            </a>.
                        </i>
                    </p>
                </div>
            </div>
        );
    }
}

export default PrintSubscriptionForm;
